module.exports = __webpack_public_path__ + "img/framee001-1.19d334c1.jpg";